module.exports = __webpack_public_path__ + "static/media/fairytale-fortune.dbf2474c.gif";